<template>
  <div>
    <AllCases :selectedStatuses="statuses"></AllCases>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const AllCases = defineAsyncComponent(() =>
  import("@/components/cases/AllCases")
);
export default {
  components: {
    AllCases,
  },
  data() {
    return {
      statuses: ["TEST_REPORTS"],
    };
  },
};
</script>
